<nav class="subnav">
  <ul class="nav">
    <li class="nav-item">
      <a class="nav-link active" [routerLink]="['/persons/overview']">Übersicht</a>
    </li>
  </ul>
</nav>

<main>
  <h2>PHM PPS  <cds-icon shape="two-way-arrows"></cds-icon>  Person hinzufügen</h2>
  <app-person-form [personForm]="personForm"></app-person-form><br>
  <button class="btn btn-danger-outline btn-small" type="submit" [disabled]="personForm.invalid" (click)="onSubmit()">Speichern</button>
  <a class="btn btn-info-outline btn-small" [routerLink]="['/persons/overview/']">Abbrechen</a>

  <pre *ngIf="devMode" class="datepicker-output">{{ personForm }}</pre>
</main>
